import React, { useState } from "react";
import { updateEncounterDetails } from "apiHandler/actions";
import { Button, TextField } from "@mui/material";
import EditIcon from "@material-ui/icons/Edit";
import {
  fixDate,
  displayDateFormatter,
  isoDateFormatter,
} from "components/helpers";
import { useUserData } from "components/customHooks/userDataContext";
import ButtonProgress from "components/ButtonProgress";
import dayjs from "dayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers";

const EncouterInfo = ({
  provider_name,
  provider_first_name,
  provider_last_name,
  dos,
  dictation_id,
  encounter_id,
  chief_complaint,
  location,
  practice_id,
  npi,
  setEncounterId,
  readOnly,
  appt_type,
  details,
}) => {
  const initialState = () => {
    return {
      provider_name: provider_first_name + " " + provider_last_name,
      dos: fixDate(dos),
      chief_complaint: chief_complaint,
      location: location,
      appt_type,
    };
  };

  const [editEncounterInfo, setEditEnocunterInfo] = useState(false);
  const [encounterInfo, setEncounterInfo] = useState(initialState());
  const [isSaving, setIsSaving] = useState(false);
  const userData = useUserData();
  const token = userData?.access_token;

  const onSave = async () => {
    setIsSaving(true);
    const { chief_complaint, location, provider_name, dos } = encounterInfo;
    const payload = {
      type: "Encounter",
      record_data: {
        practice_id: practice_id,
        npi: npi,
        dictation_id: dictation_id,
        scribe_id: userData.email,
        appt_type,
        dos: isoDateFormatter(dos),
        provider_name: provider_name,
        location: location,
        chief_complaint: chief_complaint,
        user_name: userData.first_name + " " + userData.last_name,
      },
    };
    if (encounter_id) payload["record_data"]["encounter_id"] = encounter_id;
    const response = await updateEncounterDetails(payload, token);
    if (response !== "ERROR") {
      await setEditEnocunterInfo(false);
      if (!encounter_id) setEncounterId(response.encounter_id);
    }
    setIsSaving(false);
  };

  return (
    <div className="dictation-notes">
      <div className="edit">
        <p>Encounter info</p>
        {readOnly ||
          (!editEncounterInfo && (
            <EditIcon
              color="secondary"
              fontSize={"small"}
              onClick={() => setEditEnocunterInfo(true)}
            />
          ))}
      </div>
      <div className="note-main-container">
        <div className="notes-cont">
          <p className="notes-title">Dictation Id</p>
          <div className="notes-content">{dictation_id || "-"}</div>
        </div>
        <div className="notes-cont">
          <p className="notes-title">Encounter Id</p>
          <div className="notes-content">{encounter_id || "-"}</div>
        </div>
        <div className="notes-cont">
          <p className="notes-title">Provider</p>
          {!editEncounterInfo ? (
            <div className="notes-content">{provider_name || "-"}</div>
          ) : (
            <TextField
              value={encounterInfo.provider_name}
              onChange={(e) =>
                setEncounterInfo({
                  ...encounterInfo,
                  provider_name: e.target.value,
                })
              }
              className="notes-content"
              size="small"
            />
          )}
        </div>
        <div className="notes-cont">
          <p className="notes-title">DOS</p>
          {!editEncounterInfo ? (
            <div className="notes-content">
              {displayDateFormatter(encounterInfo.dos) || "-"}
            </div>
          ) : (
            <DesktopDatePicker
              disableToolbar
              slotProps={{
                textField: {
                  variant: "standard",
                },
              }}
              format="MM/DD/YYYY"
              value={dayjs(encounterInfo.dos)}
              onChange={(e) => setEncounterInfo({ ...encounterInfo, dos: e })}
              className="notes-content"
              autoOk
            />
          )}
        </div>
        <div className="notes-cont">
          <p className="notes-title">Chief Complaint</p>
          {!editEncounterInfo ? (
            <div className="notes-content">
              {encounterInfo.chief_complaint || "-"}
            </div>
          ) : (
            <TextField
              value={encounterInfo.chief_complaint}
              onChange={(e) =>
                setEncounterInfo({
                  ...encounterInfo,
                  chief_complaint: e.target.value,
                })
              }
              className="notes-content"
              size="small"
            />
          )}
        </div>
        <div className="notes-cont">
          <p className="notes-title">Appointment Type</p>
          {!editEncounterInfo ? (
            <div className="notes-content">
              {encounterInfo.appt_type || "-"}
            </div>
          ) : (
            <TextField
              value={encounterInfo.appt_type}
              onChange={(e) =>
                setEncounterInfo({
                  ...encounterInfo,
                  appt_type: e.target.value,
                })
              }
              className="notes-content"
              size="small"
            />
          )}
        </div>

        <div className="notes-cont">
          <p className="notes-title">Location</p>
          {!editEncounterInfo ? (
            <div className="notes-content">{encounterInfo.location || "-"}</div>
          ) : (
            <TextField
              value={encounterInfo.location}
              onChange={(e) =>
                setEncounterInfo({ ...encounterInfo, location: e.target.value })
              }
              className="notes-content"
              size="small"
            />
          )}
        </div>
        <div className="notes-cont">
          <p className="notes-title">Practice Encounter Id</p>
          <div className="notes-content">
            {details?.practice_encounter_id || "-"}
          </div>
        </div>
        <div className="notes-cont">
          <p className="notes-title">Patient Id</p>
          <div className="notes-content">
            {details?.practice_patient_id || "-"}
          </div>
        </div>
      </div>
      {editEncounterInfo && (
        <div className="update-btn-cont">
          <Button className="update" onClick={onSave}>
            {isSaving ? <ButtonProgress size={16} /> : "Update"}
          </Button>
          <Button
            className="cancel"
            onClick={() => {
              setEditEnocunterInfo(false);
              setEncounterInfo(initialState());
            }}
          >
            Cancel
          </Button>
        </div>
      )}
    </div>
  );
};

export default EncouterInfo;
